"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtraLabels = void 0;
const enums_1 = require("../../../../global/enums");
const ExtraLabelsInEnglish = {
    referenceNumber: 'Reference #',
    ticketNumber: 'Ticket #',
    wpTransactionNumber: 'Transaction ID',
    responseCode: 'Response Code',
    agreement: 'I AGREE TO PAY THE ABOVE TOTAL AMOUNT ACCORDING TO CARD ISSUER AGREEMENT',
    customerSignature: 'Customer Signature',
    merchantSignature: 'Merchant Signature',
    merchantCopy: 'Merchant Copy',
    customerCopy: 'Customer Copy',
    thankYou: 'Thank you',
    approved: 'Approved',
    partiallyApproved: 'Partially Approved',
    declined: 'Transaction Not Approved',
    checking: 'Chequing',
    savings: 'Savings',
    transactionTimedOut: 'The transaction has timed out.',
    pinPadError: 'PIN pad error.',
    oneOrMoreError: 'One or more errors occurred.',
    unablePinpad: 'Unable to find PIN pad.',
    cardRemoved: 'Card removed.',
    processingError: 'EMV transaction declined by card after online processing.\nThe transaction was approved online but declined by card after online processing.\nA request to reverse the online approval has been queued.',
    insertCard: 'Swiped card is chip capable. Please insert card.',
    reprint: 'REPRINT',
};
const ExtraLabelsInFrench = {
    referenceNumber: 'No Ref',
    ticketNumber: 'No Billet',
    wpTransactionNumber: 'NO. Fact',
    responseCode: 'Code de résponse',
    agreement: `JE CONSENS A PAYER CE TOTAL CONFORMEMENT A L'ENTENTE DE L'EMETTEUR`,
    customerSignature: 'Client Signature',
    merchantSignature: 'Merchand Signature',
    merchantCopy: 'Copie Du Marchand',
    customerCopy: 'Copie Client',
    thankYou: 'Merci',
    approved: 'Approuvé',
    partiallyApproved: 'Partiellement Approuvé',
    declined: 'Opération Refusée',
    checking: 'Compte chèque',
    savings: 'Compte épargne',
    transactionTimedOut: 'La transaction a expiré.',
    pinPadError: 'Erreur du clavier NIP.',
    oneOrMoreError: 'Une ou plusieurs erreurs se sont produites.',
    unablePinpad: 'Impossible de trouver le clavier NIP',
    cardRemoved: 'Carte retirée',
    processingError: `Transaction EMV refusée par carte après traitement en ligne.\nLa transaction a été approuvée en ligne mais refusée par carte après traitement en ligne.\nUne demande d'annulation de l'approbation en ligne a été mise en file d'attente.`,
    insertCard: `La carte glissée est compatible avec la puce. Veuillez insérer la carte.`,
    reprint: 'RÉIMPRESSION',
};
exports.ExtraLabels = {
    [enums_1.Language.ENGLISH]: ExtraLabelsInEnglish,
    [enums_1.Language.FRENCH]: ExtraLabelsInFrench,
};
//# sourceMappingURL=ExtraLabels.js.map